import { useTheme as t, useMediaQuery as i } from "@mui/material";
const d = (e) => {
  const s = t();
  return i(s.breakpoints.down("sm")) ? "medium" : e;
};
export {
  d as useFormFieldSize
};
//# sourceMappingURL=useFormFieldSize.mjs.map
